import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { toBatchRewind } from '@/api/correspondence/task/form';
import { json2excel } from '@/util/json2excel';
import { mapState } from 'vuex';
import { getBackConfirmExplain, transformInputCodes } from "@/util";
export default {
  name: 'correspondence-reject',
  data: function data() {
    return {
      codes: undefined,
      loading: false,
      checked: true,
      list: [],
      rows: {},
      activeNames: undefined,
      columns: ['函证编号', '函证类型', '函证对象', '发函日期', '发函快递单号', '回函快递单号', '回函日期', '收件日期', '快递公司', '到付运费', '回函寄件人', '回函寄件人联系电话', '收件地址', '回函检查说明', '领取状态'],
      requiredFields: 'c02ConfirmCode,c02Type,c03ConfirmObj,c02SendDate,c02SendNumber,c02BackConfirmDate,c02BackNumber,c02BackConfirmActualDate,c02BackFee,c02BackSendName,c02BackSendMobile,c02SendRecAddress,c02BackConfirmExplain,c02GetStatus,c02BackCompany,c02BackAddress'
    };
  },
  computed: _objectSpread({
    dataCodes: function dataCodes() {
      var codes = this.codes;
      return transformInputCodes(codes);
    }
  }, mapState('cpscc', ['backConfirmExplainList'])),
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.list = [];
              _context.n = 1;
              return _this.$awaitTo(toBatchRewind({
                requiredFields: _this.requiredFields,
                c02ConfirmCodes: _this.dataCodes
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this.list = data;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return new Promise(function (resolve, reject) {
                _this2.$confirm('请选择是否删除填写数据', '确定置为已发函?', {
                  confirmButtonText: '保留数据',
                  cancelButtonText: '清除数据',
                  type: 'warning',
                  distinguishCancelAndClose: true
                }).then(function () {
                  resolve(true);
                }).catch(function (action) {
                  if (action === 'cancel') {
                    resolve(false);
                  } else {
                    reject('已取消');
                  }
                });
              });
            case 1:
              res = _context2.v;
              _context2.n = 2;
              return _this2.$awaitTo(toBatchRewind({
                requiredFields: _this2.requiredFields,
                c02ConfirmCodes: _this2.list.map(function (item) {
                  return item.c02ConfirmCode;
                })
              }, {
                isMinimum: res
              }));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this2.$message.success('操作成功');
              _this2.codes = undefined;
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getDesc: function getDesc(row) {
      // const obj = { c02BackConfirmExplain: row.c02BackConfirmExplain, _c02BackConfirmExplain: '' }
      // if (row.c02BackConfirmExplain.indexOf(':') === 1) {
      //   const r = row.c02BackConfirmExplain.split(':')
      //   obj.c02BackConfirmExplain = r[0]
      //   obj._c02BackConfirmExplain = r[1]
      // } else {
      //   if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(row.c02BackConfirmExplain)) {
      //     const text = row.c02BackConfirmExplain
      //     obj.c02BackConfirmExplain = '0'
      //     obj._c02BackConfirmExplain = text
      //   }
      // }
      // const res = this.backConfirmExplainList.find((item) => {
      //   return item.value === obj.c02BackConfirmExplain
      // })
      // if (res) {
      //   obj.c02BackConfirmExplain = `${res.value}:${res.label}`
      // }
      // return `(${obj.c02BackConfirmExplain})${obj._c02BackConfirmExplain ? obj._c02BackConfirmExplain : ''}`
      var obj = getBackConfirmExplain(row.c02BackConfirmExplain);
      return "".concat(obj.code, ":").concat(obj.msg);
    },
    exportExcel: function exportExcel() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var columns, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              columns = _this3.columns;
              _this3.loading = true;
              data = _this3.list.map(function (item) {
                return [item.c02ConfirmCode, item.c02Type, item.c03ConfirmObj ? item.c03ConfirmObj.c03CusName : '', _this3.$options.filters.date(item.c02SendDate, 'yyyy-MM-dd'), item.c02SendNumber, item.c02BackNumber, _this3.$options.filters.date(item.c02BackConfirmDate, 'yyyy-MM-dd'), _this3.$options.filters.date(item.c02BackConfirmActualDate, 'yyyy-MM-dd'), item.c02BackCompany, item.c02BackFee, item.c02BackSendName, item.c02BackSendMobile, item.c02BackAddress, _this3.getDesc(item), item.c02GetStatus];
              });
              _context3.n = 1;
              return json2excel([columns].concat(_toConsumableArray(data)), '批量已回置已发.xlsx');
            case 1:
              _this3.loading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};